// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // ************ comment it when deploy**********
  // apiUrl: 'https://neumiapi-stage.ziplingo.com/',
  // productUrl: 'https://neumiapi-stage.ziplingo.com/',
  // imageUrl: 'https://neumi.corpadmin.directscale.com/CMS/Images/Inventory'

  // ************ uncomment it when deploy**********
  apiUrl: 'https://api.commonsensewellness.com/' ,
  productUrl: 'https://api.commonsensewellness.com/',
  imageUrl: 'https://commonsense.corpadmin.directscale.com/CMS/Images/Inventory',
  linkTracking: {
    isAllowed: false,
    companyName: "companyKey",
  },
  strapiUrl: "https://loved-cat-0a15af1223.strapiapp.com",
  // strapiUrl: "https://supportive-horse-cfa56d4186.strapiapp.com", // Staging url
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
